import { render, staticRenderFns } from "./adminAuthorization.vue?vue&type=template&id=4fbbcc6e&scoped=true"
import script from "./adminAuthorization.vue?vue&type=script&lang=js"
export * from "./adminAuthorization.vue?vue&type=script&lang=js"
import style0 from "./adminAuthorization.vue?vue&type=style&index=0&id=4fbbcc6e&prod&lang=css"
import style1 from "./adminAuthorization.vue?vue&type=style&index=1&id=4fbbcc6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbbcc6e",
  null
  
)

export default component.exports